import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon/index';
import { TooltipEl } from 'common/components/tooltip/index';
export function template() {
  return jsx("div", {
    sel: '.mp-settings-section-container'
  }, this.attr("title") ? jsx("div", {
    sel: '.mp-settings-section-header'
  }, jsx("div", {
    sel: '.mp-settings-section-title'
  }, this.attr("title"), this.attr("help-text") ? jsx("div", {
    sel: '.mp-settings-section-help-text-container'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "info"
    }
  }), jsx(TooltipEl, {
    attrs: {
      'max-width': this.attr("tooltip-max-width")
    }
  }, this.attr("help-text"))) : null), this.attr("help-link-url") ? jsx("a", {
    attrs: {
      href: this.attr("help-link-url"),
      target: "_blank"
    }
  }, this.attr("help-link-text")) : null, jsx("slot", {
    attrs: {
      name: "header-actions"
    }
  })) : null, jsx("div", {
    sel: '.mp-settings-section-ul'
  }, jsx("slot", null)));
}